module.exports = __webpack_public_path__ + "img/productHSE_3.df4f2d09.png";